// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"acf0a8cf20ae048c","705":"bfbac9ba16c9dc39","763":"f29d696f71300fc5"}[chunkId] + ".js";
};